import { render } from "./FooterComponents.vue?vue&type=template&id=51d974f0"
import script from "./FooterComponents.vue?vue&type=script&lang=js"
export * from "./FooterComponents.vue?vue&type=script&lang=js"

import "./FooterComponents.vue?vue&type=style&index=0&id=51d974f0&lang=css"

import exportComponent from "/var/www/html/p23_selfpayment_pro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__